import e from "../../../../../utils/isEmpty.js";
import { bs2ad as t } from "../../calendar-carburettor/converter/index.js";
import n from "../../calendar-carburettor/converter/look-up.js";
import { stitch_date as r } from "./stitch_date.js";
import { split_date as i } from "./split_date.js";
// src/design/forms/datepicker/calendar-engine/utilities/parse_date.ts
var a = (a, o = "-") => {
	if (e(a)) return null;
	let { year: s, month: c, day: l } = i(a, o), u = new Date(t(a));
	return {
		adDate: u,
		bsDay: l,
		bsMonth: c,
		bsYear: s,
		firstAdDayInBSMonth: new Date(t(r({
			year: s,
			month: c,
			day: 1
		}, o))),
		numberOfDaysInBSMonth: n.queryDays(s, c),
		weekDay: u.getDay()
	};
};
export { a as parse_date };

//# sourceMappingURL=parse_date.js.map